import DynamicHero from './DynamicHero'

export default DynamicHero